// This replaces the BrowserRouter's history object

import { createBrowserHistory } from 'history';
export default createBrowserHistory();